import { Component } from '@angular/core';
import { AccountService } from './services/account.service';
import { GuardsCheckEnd, NavigationCancel, NavigationStart, Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent {
  title = 'ZfConfigTool';

  constructor(private router: Router) {
  }

  ngOnInit(): void {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart){
        if (!event.url.includes("software") && !event.url.includes("rollout")) {
          localStorage.setItem("dropdown", "");
        }
      }
      if (event instanceof GuardsCheckEnd || event instanceof NavigationCancel) {
        document.getElementById("loading-screen")?.remove();
      }
    });
  }
}
